// api.js

import axios from 'axios';
import { roles } from './Constants';

function normalizeJwt(rawToken) {
  if (!rawToken) return null;
  return rawToken.startsWith('Bearer ') ? rawToken.slice(7) : rawToken;
}

function decodeJwtPayload(token) {
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const json = atob(padded);
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
}

function buildExpectedAudiences() {
  const values = [
    process.env.REACT_APP_BACKEND_SCOPE,
    process.env.REACT_APP_BACKEND_CLIENT_ID,
    process.env.REACT_APP_CLIENT_ID,
  ].filter(Boolean);

  const auds = new Set(values);
  values.forEach((value) => {
    if (value.startsWith('api://')) {
      auds.add(value.replace('api://', ''));
    }
  });

  return auds;
}

function hasExpectedAudience(token, expectedAudiences) {
  const payload = decodeJwtPayload(token);
  if (!payload || !payload.aud) return false;

  if (Array.isArray(payload.aud)) {
    return payload.aud.some((aud) => expectedAudiences.has(String(aud)));
  }

  return expectedAudiences.has(String(payload.aud));
}

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_ROOT_URL_PREFIX, // Your API base URL
});

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    // Add your custom headers here
    const expectedAudiences = buildExpectedAudiences();
    const candidates = [
      localStorage.getItem("snowtoken"),
      localStorage.getItem("Authorization"),
    ].filter(Boolean);

    let jwtToken = null;
    for (const candidate of candidates) {
      const normalized = normalizeJwt(candidate);
      if (!normalized) continue;

      if (expectedAudiences.size === 0 || hasExpectedAudience(normalized, expectedAudiences)) {
        jwtToken = normalized;
        break;
      }
    }

    if (!jwtToken && candidates.length > 0) {
      console.warn("[API] Token audience mismatch. Clearing stale tokens.");
      localStorage.removeItem("snowtoken");
      localStorage.removeItem("Authorization");
    }

    if (jwtToken) {
      config.headers['Authorization'] = `Bearer ${jwtToken}`;
      config.headers['x-access-token'] = jwtToken;
    }
    if (roles.roleToken) {
      config.headers['x-role-token'] = roles.roleToken;
      console.log("[API] Added x-role-token header to request");
    }

    // You can add more headers or modify the existing ones as needed
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
